import { schema } from 'normalizr'

export const documentSchema = new schema.Entity(
  'documents',
  {},
  {
    idAttribute: 'idname',
  }
)

export const codiDocumentSchema = new schema.Entity(
  'codi_documents',
  { document: documentSchema },
  {
    idAttribute: 'idname',
  }
)
